import React from "react";
import { IGuestApi } from "@greeter/api";

export type GreeterGuestApiContextProps = {
  api: IGuestApi;
};
export const GreeterGuestApiContext =
  React.createContext<GreeterGuestApiContextProps>({ api: {} as any });

export function GreeterGuestApiProvider(
  props: GreeterGuestApiContextProps & React.PropsWithChildren
) {
  return (
    <GreeterGuestApiContext value={{ api: props.api }}>
      {props.children}
    </GreeterGuestApiContext>
  );
}

export function useGreeterGuestApi() {
  return React.useContext(GreeterGuestApiContext);
}
